import type { SupportedLanguage } from '../i18n/types.no-deps'

/**
 * Helper function to return language-sensitive formatting for the given list and language code e.g.
 *
 * languageSensitiveListFormatter (["Elm", "React", "Typescript"], "en-GB"); // 'Elm, React and Typescript'
 */
export function languageSensitiveListFormatter(itemNames: string[], lang: SupportedLanguage): string {
    if (itemNames.length === 0) return ''

    const formatter = new Intl.ListFormat(lang, {
        style: 'long',
        type: 'conjunction',
    })

    return formatter.format(itemNames)
}
